
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-charts/hooks/use-scale",
      function () {
        return require("private-next-pages/x/react-charts/hooks/use-scale.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-charts/hooks/use-scale"])
      });
    }
  